import React, { Component } from 'react';
import Modal from 'react-modal';
import Header from './Header/Header';
import NotificationBar from './NotificationBar/NotificationBar';
import Settings from './Settings/Settings';
import History from './History/History';
import FavoritesModal from './Modals/FavoritesModal';
import WorkingHoursModal from './Modals/WorkingHoursModal';
import AboutTimeTrackerModal from './Modals/AboutTimeTrackerModal';
import ReportErrorModal from './Modals/ReportErrorModal';
import LocationListModal from './Modals/LocationListModal';
import OpportunityListModal from './Modals/OpportunityListModal';
import DateFilterPickerModal from './Modals/DateFilterPickerModal';
import { connect } from "react-redux";
import {
    toggleSettings,
    toggleHistory,
    modalController
} from '../actions/domActions';
import _ from 'underscore';

require('../index.scss');

// Global Modal settings
import MODAL_SETTINGS from '../styles/modalSettings';

function mapStateToProps (state, ownProps) {
    return {
        isAboutTimeTrackerOpen: state.modal.isAboutTimeTrackerOpen,
        isAddFavoritesOpen: state.modal.isAddFavoritesOpen,
        isDateFilterPickerOpen: state.modal.isDateFilterPickerOpen,
        isEditFavoritesOpen: state.modal.isEditFavoritesOpen,
        isHistoryOpen: state.dom.isHistoryOpen,
        isLocationListOpen: state.modal.isLocationListOpen,
        isOpportunityListOpen: state.modal.isOpportunityListOpen,
        isReportErrorOpen: state.modal.isReportErrorOpen,
        isSettingsOpen: state.dom.isSettingsOpen,
        isWorkingHoursOpen: state.modal.isWorkingHoursOpen,
        locationsFrom: state.modal.locationsFrom,
        notifications: state.notifications,
        opportunitiesFor: state.modal.opportunitiesFor,
        settings: state.settings,
        user: state.user
    };
}

function mapDispatchToProps (dispatch, ownProps) {
    return {
        toggleSettings: (isSettingsOpen) =>
            dispatch(toggleSettings(isSettingsOpen)),
        toggleHistory: (isHistoryOpen) =>
            dispatch(toggleHistory(isHistoryOpen)),
        modalController: (currentModal) =>
            dispatch(modalController(currentModal))
    };
}

class Container extends Component {
    toggleSettings () {
        this.props.toggleSettings(this.props.isSettingsOpen);
    }

    toggleHistory () {
        this.props.toggleHistory(this.props.isHistoryOpen);
    }

    modalController (currentModal) {
        this.props.modalController(currentModal);
    }

    _renderModals () {
        const baseModal = {
            type: null,
            label: "Modal",
            isOpen: false,
            props: {},
            closeType: "CLOSE_ALL"
        };

        return [
            _.extend({}, baseModal, {
                type: FavoritesModal,
                label: "Favorites modal",
                isOpen: this.props.isEditFavoritesOpen,
                props: {
                    addFavBtn: () => this.modalController("ADD_FAVORITES")
                }
            }),
            _.extend({}, baseModal, {
                type: WorkingHoursModal,
                label: "Working hours modal",
                isOpen: this.props.isWorkingHoursOpen
            }),
            _.extend({}, baseModal, {
                type: AboutTimeTrackerModal,
                label: "About modal",
                isOpen: this.props.isAboutTimeTrackerOpen
            }),
            _.extend({}, baseModal, {
                type: ReportErrorModal,
                label: "Report error modal",
                isOpen: this.props.isReportErrorOpen
            }),
            _.extend({}, baseModal, {
                type: LocationListModal,
                label: "Location modal",
                isOpen: this.props.isLocationListOpen,
                closeType: "CLOSE_LOCATIONS"
            }),
            _.extend({}, baseModal, {
                type: OpportunityListModal,
                label: "Opportunity modal",
                isOpen: this.props.isOpportunityListOpen,
                closeType: "CLOSE_OPPORTUNITIES"
            }),
            _.extend({}, baseModal, {
                type: DateFilterPickerModal,
                label: "Select date range modal",
                isOpen: this.props.isDateFilterPickerOpen
            })
        ].map((modal, i) => {
            const ModalType = modal.type;
            const baseModalProps = {
                ariaHideApp: false,
                key: i,
                isOpen: modal.isOpen,
                onRequestClose: () => this.modalController(modal.closeType),
                style: MODAL_SETTINGS,
                contentLabel: modal.label
            };
            const modalProps = _.extend(modal.props, {
                closeModal: () => this.modalController(modal.closeType)
            });
            return (
                <Modal {...baseModalProps}>
                    <ModalType {...modalProps} />
                </Modal>
            );
        });
    }

    render () {
        let showNotification = this.props.settings.notifications;
        const panelDefault = {height: 'calc(100vh - 65px)'};
        const panelWNotification = {height: 'calc(100vh - 125px)'};
        let displayNoticiation = this.props.settings.notifications &&
            (this.props.notifications.pending.length > 0);

        return (
            <main className="container-fluid">
                <Header settingToggle={this.toggleSettings.bind(this)}
                    historyToggle={this.toggleHistory.bind(this)}
                    historyStatus={this.props.isHistoryOpen}
                    settingsStatus={this.props.isSettingsOpen}
                />
                {this.props.isSettingsOpen && <Settings />}
                {showNotification ? <NotificationBar/> : <div className="notificationBar"></div>}
                <section className="row mgttwrap"
                    style={displayNoticiation ? panelWNotification : panelDefault}
                >
                    <History isOpen={this.props.isHistoryOpen}/>
                    <article>{this.props.children}</article>
                </section>
                <section>
                    {this._renderModals()}
                </section>
            </main>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container);



// WEBPACK FOOTER //
// ./app/components/container.jsx